// New-order sound that also works on iPad/iPhone.
// iOS only lets an <audio> element play without a tap if that same element was
// started once inside a user gesture, so we reuse one element and "unlock" it
// on the first touch/click instead of creating a new Audio() per order.

const audio = new Audio("/audio/notification.mp3");
audio.preload = "auto";

let unlocked = false;

const UNLOCK_EVENTS = ["touchend", "pointerdown", "click", "keydown"];

function unlock() {
  if (unlocked) return;
  audio.muted = true;
  const attempt = audio.play();
  if (attempt && attempt.then) {
    attempt
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
        audio.muted = false;
        unlocked = true;
        UNLOCK_EVENTS.forEach((e) => window.removeEventListener(e, unlock));
      })
      .catch(() => {
        audio.muted = false; // try again on the next gesture
      });
  }
}

export function initOrderSound() {
  UNLOCK_EVENTS.forEach((e) => window.addEventListener(e, unlock));
}

export function playOrderSound() {
  audio.muted = false;
  audio.currentTime = 0;
  audio.play().catch((err) => console.log("Audio blocked:", err));
}

// Keep the tablet screen on while the admin is open; a sleeping iPad suspends
// the page, which drops the socket and misses new-order events.
let wakeLock = null;

async function requestWakeLock() {
  try {
    if ("wakeLock" in navigator && document.visibilityState === "visible") {
      wakeLock = await navigator.wakeLock.request("screen");
    }
  } catch (err) {
    console.log("Wake lock unavailable:", err);
  }
}

export function keepScreenAwake() {
  requestWakeLock();
  // The lock is released whenever the tab is hidden; re-acquire on return.
  const onVisible = () => {
    if (document.visibilityState === "visible") requestWakeLock();
  };
  document.addEventListener("visibilitychange", onVisible);
  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    if (wakeLock) wakeLock.release().catch(() => {});
    wakeLock = null;
  };
}
